export class DateUtility {

    public static getDateFormat(date : Date): string {

        let dia = '';
        let mes = '';
        let anio = '';

        let _dia = date.getDate();
        let _mes = date.getMonth() + 1;
        let _anio = date.getFullYear();
        console.log(_dia);

        if(_dia < 10){
            dia = '0';
        }

        if(_mes < 10){
            mes = '0';
        }

        dia += _dia;
        mes += _mes;
        anio += _anio;

        return dia + '/' + mes + '/' + anio;

    }

    public static getHourFormat(date : Date) : string {
        
        let hora = '';
        let min = '';
        let zona = '';

        let _hora = date.getHours();
        let _min = date.getMinutes();

        if(_hora < 10){
            hora = '0';
        }

        if(_min < 10){
            min = '0';
        }       

        if(_hora < 12){
            zona = 'AM';
        }else{
            zona = 'PM';
            if(_hora > 12 ){
                _hora = _hora - 12;
            }
            
        }

        hora += _hora;
        min += _min;

        return hora + ':' + min + ' ' + zona;
    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/utilities/date.utility.ts